// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referral-landing {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg-root);
  padding: 24px 16px;
}

.referral-landing-card {
  width: min(420px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 32px 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: referralLandingIn 0.2s ease;
}

@keyframes referralLandingIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.referral-landing-badge {
  align-self: flex-start;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-accent-base);
  border: 1px solid var(--color-accent-base);
  padding: 3px 8px;
}

.referral-landing-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--color-text-primary);
}

.referral-landing-brand {
  color: var(--color-accent-base);
}

.referral-landing-subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-text-secondary);
}

.referral-landing-subtitle strong {
  color: var(--color-text-primary);
}

.referral-landing-steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
}

.referral-landing-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.referral-landing-step-number {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--color-text-on-accent);
  background: var(--color-accent-base);
}

.referral-landing-step div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.referral-landing-step strong {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.referral-landing-step span {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.referral-landing-google {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  font-family: inherit;
  transition: background 0.15s ease;
}

.referral-landing-google:hover {
  background: var(--color-bg-user-bubble);
}

.referral-landing-google img {
  width: 16px;
  height: 16px;
}

.referral-landing-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.referral-landing-divider::before,
.referral-landing-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--color-border-input);
}

.referral-landing-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.referral-landing-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-secondary);
}

.referral-landing-label input {
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
}

.referral-landing-label input:focus {
  outline: none;
  border-color: var(--color-accent-base);
}

.referral-landing-submit {
  padding: 10px 12px;
  border: none;
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  font-family: inherit;
}

.referral-landing-submit:disabled {
  opacity: 0.6;
  cursor: default;
}

.referral-landing-error {
  color: var(--color-danger, #e55);
  font-size: 12px;
}

.referral-landing-footer {
  font-size: 11px;
  color: var(--color-text-secondary);
  line-height: 1.4;
}

.referral-landing-footer a {
  color: var(--color-text-secondary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.referral-landing-footer a:hover {
  color: var(--color-text-primary);
}

@media (max-width: 640px) {
  .referral-landing-card {
    padding: 24px 18px;
  }

  .referral-landing-title {
    font-size: 19px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ReferralLandingPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".referral-landing {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-bg-root);\n  padding: 24px 16px;\n}\n\n.referral-landing-card {\n  width: min(420px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 32px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: referralLandingIn 0.2s ease;\n}\n\n@keyframes referralLandingIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.referral-landing-badge {\n  align-self: flex-start;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--color-accent-base);\n  border: 1px solid var(--color-accent-base);\n  padding: 3px 8px;\n}\n\n.referral-landing-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--color-text-primary);\n}\n\n.referral-landing-brand {\n  color: var(--color-accent-base);\n}\n\n.referral-landing-subtitle {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n}\n\n.referral-landing-subtitle strong {\n  color: var(--color-text-primary);\n}\n\n.referral-landing-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n}\n\n.referral-landing-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.referral-landing-step-number {\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--color-text-on-accent);\n  background: var(--color-accent-base);\n}\n\n.referral-landing-step div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.referral-landing-step strong {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.referral-landing-step span {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.referral-landing-google {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  font-family: inherit;\n  transition: background 0.15s ease;\n}\n\n.referral-landing-google:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.referral-landing-google img {\n  width: 16px;\n  height: 16px;\n}\n\n.referral-landing-divider {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.referral-landing-divider::before,\n.referral-landing-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--color-border-input);\n}\n\n.referral-landing-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.referral-landing-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--color-text-secondary);\n}\n\n.referral-landing-label input {\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n}\n\n.referral-landing-label input:focus {\n  outline: none;\n  border-color: var(--color-accent-base);\n}\n\n.referral-landing-submit {\n  padding: 10px 12px;\n  border: none;\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.referral-landing-submit:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.referral-landing-error {\n  color: var(--color-danger, #e55);\n  font-size: 12px;\n}\n\n.referral-landing-footer {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  line-height: 1.4;\n}\n\n.referral-landing-footer a {\n  color: var(--color-text-secondary);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.referral-landing-footer a:hover {\n  color: var(--color-text-primary);\n}\n\n@media (max-width: 640px) {\n  .referral-landing-card {\n    padding: 24px 18px;\n  }\n\n  .referral-landing-title {\n    font-size: 19px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
